import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.network.widget.detail');
import { OnInit, Input, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-network-widget-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.network.widget.detail/view.scss */
/* src/app/portal.network.widget.detail/view.scss: no such file or directory */`],
})
export class PortalNetworkWidgetDetailComponent implements OnInit {
    @Input() data!: ResearcherData;
    @Input() period: any;

    public summaryItems = [
        { key: 'total', label: '전체', count: 0 },
        { key: 'paper', label: '논문', count: 0 },
        { key: 'patent', label: '특허', count: 0 },
        { key: 'report', label: '보고서', count: 0 },
    ];
    public top3auth = [];
    public authMap: any;
    public f_index = 0;
    public l_index = 0;
    public periodStart = 0;
    public periodEnd = 0;
    public filtered: any[] = [];

    constructor(@Inject( Service)         public service: Service,    ) { }


    public ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            this.periodEnd = this.period.end;
            this.periodStart = this.period.start;
            this.load();
        }
        this.service.render();
    }


    public async ngOnInit() {
        await this.load();
        await this.service.render();
    }

    public async load() {
        try {
            this.filtered = this.data?.products.filter(p => {
                const year = Number(p.pub_year);
                return year >= this.periodStart && year <= this.periodEnd;
            });
            this.service.render();
        } catch (err) {
            toastr.error('데이터 계산 중 오류가 발생했습니다.');
            this.filtered = [];
        }
        if (this.filtered) {
            this.summaryItems = this.summaryItems.map(item => ({
                ...item,
                count: item.key === 'total'
                    ? this.filtered.length
                    : this.filtered.filter((p: any) => p.category === item.key).length
            }));
        }
        this.checkIndex();
        this.checkTop3();
        this.service.render();
    }

    private checkIndex() {

        if (!this.filtered || !this.data.researcher?.auth_id) return;
        let f = 0;
        let l = 0;

        const papers = this.filtered.filter((p: any) => p.category === "paper");

        papers.forEach((p: any) => {
            if (!p.auth_list) return;

            const authors = p.auth_list.split(';').map((a: string) => a.trim());

            if (authors.length > 0) {
                const first = authors[0];
                const last = authors[authors.length - 1];

                if (first === this.data.researcher.auth_id) {
                    f++;
                    if (last === this.data.researcher.auth_id) {
                        return;
                    }
                }

                if (last === this.data.researcher.auth_id) {
                    l++;
                }
            }
        });

        this.f_index = papers.length > 0 ? Number(((f / papers.length) * 100).toFixed(2)) : 0;
        this.l_index = papers.length > 0 ? Number(((l / papers.length) * 100).toFixed(2)) : 0;

        this.service.render();
    }

    private async checkTop3() {
        const authorIdFreq: Record<string, number> = {};
        const myId = this.data.researcher?.auth_id?.trim();
        for (const p of (this.filtered ?? [])) {
            const authorIds = (p.auth_list ?? "")
                .split(";")
                .map(x => x.trim())
                .filter(Boolean)
                .filter((x: string) => x !== myId) || [];
            for (const id of authorIds) {
                authorIdFreq[id] = (authorIdFreq[id] || 0) + 1;
            }
        }

        this.buildTop3Ranks(authorIdFreq);
    }

    private async buildTop3Ranks(authorIdFreq) {
        const entries = Object.entries(authorIdFreq) as [string, number][];

        entries.sort((a, b) => b[1] - a[1]); //내림차순

        // 2) 서로 다른 count 값 상위 3개 추출
        const distinctCounts: number[] = [];
        for (const [, count] of entries) {
            if (!distinctCounts.includes(count)) {
                distinctCounts.push(count);
                if (distinctCounts.length === 3) break;
            }
        }

        // 3) 각 count별로 사람 묶기
        this.top3auth = distinctCounts.map((count, idx) => {
            const authors = entries
                .filter(([_, c]) => c === count)
                .map(([name]) => name);
            return {
                rank: idx + 1,
                count,
                authors
            };
        });
        const { code, data } = await wiz.call("search", { "top3": JSON.stringify(this.top3auth) });
        this.authMap = data;
    }

    public authorsParts(a: any): Array<{ id: string; name: string; link: boolean }> {
        const ids: string[] = a?.authors ?? [];
        const list = this.authMap ?? [];

        return ids.map((id) => {
            const found = list.find((x: any) => x.id === id);
            return {
                id,
                name: found?.name ?? id,
                link: !!found?.link
            };
        });
    }

    public openAuthor(id: string) {
        window.open(`/detail/${id}`, '_blank');
    }

    //modal 

    // 모달 상태
    modalOpen = false;
    modalTitle = '';
    modalItems: ModalItem[] = [];
    modalMessage: string | null = null;

    public openModal(p) {
        if (p.key == 'total') {
            this.modalItems = this.filtered;
        } else this.modalItems = (this.filtered ?? []).filter(item => item.category === p.key);
        const item = this.summaryItems.find(i => i.key === p.key);
        this.modalTitle = item?.label ?? '';
        this.modalOpen = true;
        this.service.render();
    }

    public scienceOnUrl(p: any): string {
        const cn = p?.doc_num || '';
        if (!cn) return '#';

        switch (p?.category) {
            case 'report':
                return `https://scienceon.kisti.re.kr/srch/selectPORSrchReport.do?cn=${cn}`;
            case 'paper':
                return `https://scienceon.kisti.re.kr/srch/selectPORSrchArticle.do?cn=${cn}`;
            case 'patent':
                return `https://scienceon.kisti.re.kr/srch/selectPORSrchPatent.do?cn=${cn}`;
            default:
                return '#';
        }
    }



    public closeModal() {
        this.modalOpen = false;
        this.modalItems = [];
        this.modalMessage = null;
        this.modalTitle = '';
        this.modalSubtitle = '';
        this.service.render();
    }

}

export default PortalNetworkWidgetDetailComponent;